import Header from 'components/_OldDesign/header';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import style from 'styles/Content.module.scss';
import cultureStyle from 'styles/culture.module.scss';
import { GetStaticProps } from 'next';
import 'react-multi-carousel/lib/styles.css';
import {
  be,
  ContentItem,
  SubContent,
  turnstileSiteKey,
} from 'models/conent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';
import { useRouter } from 'next/router';
import { filterContent, findContentByTitle, translate } from 'utils/translate';
import Content from 'components/_OldDesign/content';
import { titleOnly } from 'utils/translate';
import axios from 'axios';
import { GTMPageView } from 'utils/gtm';
import { NextPageWithLayout } from './_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import fetchStrapi from 'lib/fetchStrapi';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { useInView } from 'framer-motion';
import Link from 'next/link';
import { Button } from '@components/Common';
import { captureException } from '@sentry/react';
import ErrorModal from '../components/shared/ErrorModal';
import Turnstile from 'react-cloudflare-turnstile';
import { useForm } from 'react-hook-form';
import { HoneyPot } from '@components/HoneyPot';
import { formatRules, requiredRule } from 'utils/validation';

export const getStaticProps: GetStaticProps = async () => {
  try {
    const contents = await fetchStrapi('/culture-careers', 3);
    return {
      props: {
        contents,
      },
    };
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
};

const DEFAULT_MESSAGE_TH = (
  <>
    <div className="text-lg font-semibold text-center text-red-600 mb-2">
      เกิดข้อผิดพลาด
    </div>
    <div className="text-center text-gray-700 mb-4">
      คุณสามารถติดต่อแอดมินโดยตรงได้ที่
      <br />
      <Link href="mailto:candidates@codium.co">
        <span className="font-bold text-blue-600">candidates@codium.co</span>
      </Link>
      <br />
      เราขออภัยในความไม่สะดวก
    </div>
  </>
);

const DEFAULT_MESSAGE_EN = (
  <>
    <div className="text-lg font-semibold text-center text-red-600 mb-2">
      Oops! Something went wrong.
    </div>
    <div className="text-center text-gray-700 mb-4">
      You can contact our admin directly at
      <br />
      <Link href="mailto:candidates@codium.co">
        <span className="font-bold text-blue-600">candidates@codium.co</span>
      </Link>
      <br />
      We apologize for the inconvenience.
    </div>
  </>
);

type FormValue = {
  name: string;
  email: string;
  phoneNumber: string;
  reason: string;
  none: any;
  user_code: string;
};

const fieldMap = {
  name: 'name',
  email: 'email',
  phoneNumber: 'phoneNumber',
  reason: 'reason',
};

// The registered name, not the CMS name. They coincide for every field the
// forms ship with today, but an editor can add one that `fieldMap` does not
// know — registering those under a shared 'none' key made two such fields
// collide and hid their errors, so a required one killed submit silently.
const fieldNameOf = (name: string) => fieldMap[name] || name || 'none';

// Careers are paused: the site no longer accepts resumes and the backend has
// removed POST /api/resumes. Flip this back on together with that route.
const CAREERS_ENABLED = false;

const ESignature: NextPageWithLayout<{ contents }> = ({ contents }) => {
  const [showReason, setShowReason] = useState<string>(null);
  const [showCareer, setShowCareer] = useState<string>(null);
  const [showBenefit, setShowBenefit] = useState<SubContent>(null);
  const [showJoinTeam, setShowJoinTeam] = useState(null);
  const [skelton, setSkelton] = useState(null);
  const [upload, setUpload] = useState(null);
  const { lang, setLang } = useLocale();

  const router = useRouter();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValue>();
  const [resume, setResume] = useState<any>(null);
  const [position, setPosition] = useState<any>(null);
  const [showNoti, setShowNoti] = useState<any>(false);
  const [showUploadResumeNoti, setShowUploadResumeNoti] =
    useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const benefitSectionRef = useRef();
  const isBenefitSectionInView = useInView(benefitSectionRef);

  const [confirmRecaptcha, setConfirmRecaptcha] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  useEffect(() => {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);

  useEffect(() => {
    const htmlElement = document.documentElement;

    if (showJoinTeam) {
      htmlElement.style.overflow = 'hidden';
    } else {
      htmlElement.style.overflow = '';
    }
  }, [showJoinTeam]);

  useEffect(() => {
    if (!isBenefitSectionInView && showBenefit) {
      setBenefit(null);
    }
  }, [isBenefitSectionInView]);

  useEffect(() => {
    const defaultLocale = localStorage.getItem('lang') ?? 'th';
    setLang(defaultLocale as Lang);
    setSkelton(true);
    const t = setTimeout(() => {
      setSkelton(false);
    }, 3000);

    return () => {
      clearTimeout(t);
    };
  }, [router]);

  const showReasonWhy = (reason: string) => {
    setShowReason(reason);
  };
  const setShowCareerPosition = (career: string) => {
    setShowCareer(showCareer === career ? null : career);
  };
  const setBenefit = (benefit: SubContent) => {
    setShowBenefit(benefit);
  };

  const findContent = (item, name) => {
    if (!item) return;
    return item.find((item) => item.name === name || item.title === name);
  };

  const animation = (title: string) => {
    const text = title?.split('');
    return text?.map((item, i) => (
      <span
        data-aos="zoom-in"
        data-aos-delay={`${i}50`}
        data-aos-duration={`50`}
        key={i}
      >
        {item}
      </span>
    ));
  };

  const joinTeam = (title: string, item: ContentItem) => {
    setPosition(title);
    setShowJoinTeam(item);
  };

  const closeJoinTeam = () => {
    setShowJoinTeam(null);
  };

  const handleRecaptchaChange = (token: string) => {
    setRecaptchaToken(token);
  };

  const handleSubmitForm = (data: FormValue, e: any) => {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!resume) {
      setShowUploadResumeNoti(true);
      return;
    }
    setShowUploadResumeNoti(false);

    if (!recaptchaToken) {
      alert(
        lang === 'en'
          ? 'Please confirm that you are not a robot.'
          : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์',
      );
      return;
    }

    setIsSubmitting(true);
    submit(data, recaptchaToken);
  };

  const submit = async (data: FormValue, recaptchaToken: string) => {
    const formData = new FormData();
    formData.append('cv', resume);
    formData.append(
      'data',
      JSON.stringify({
        name: data.name,
        phoneNumber: data.phoneNumber,
        email: data.email,
        reason: data.reason,
        position,
        recaptcha: recaptchaToken,
      }),
    );

    try {
      await axios.post(`${be}/api/resumes/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      GTMPageView(window.location.href, 'careerFormSubmit');
      setAlert(true);
    } catch (error) {
      setShowErrorModal(true);
      captureException(error);
    } finally {
      setResume(null);
      reset();
      setShowJoinTeam(false);
      setRecaptchaToken('');
      setIsSubmitting(false);
    }
  };
  const setAlert = (success: boolean) => {
    if (success) {
      setIsSuccess(true);
    } else {
      setIsSuccess(false);
    }
    setShowNoti(true);
    setTimeout(() => {
      setShowNoti(false);
    }, 2000);
  };
  const onFileChange = (event) => {
    setResume(event.target.files[0]);
  };

  return (
    <>
      {showNoti ? (
        <div
          className={`top-20 right-3 fixed w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md ${
            isSuccess
              ? 'bg-green-100 border-green-500 text-green-900'
              : 'bg-red-100 border-red-500 text-red-900'
          }`}
          role="alert"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="300"
          style={{ zIndex: 99 }}
        >
          <div className="flex">
            <p className="font-bold">
              {isSuccess ? (
                'Success'
              ) : (
                <>
                  Something wrong! <br />
                  Please try again later.
                </>
              )}
            </p>
          </div>
        </div>
      ) : (
        ''
      )}
      <ErrorModal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
      >
        {lang === 'en' ? DEFAULT_MESSAGE_EN : DEFAULT_MESSAGE_TH}
      </ErrorModal>
      {/* Intro */}
      {skelton ? (
        <Skeleton style={{ height: 'calc(30vw + 30vh)' }} />
      ) : (
        <div
          className={`relative ${style.header} mt-10  h-screen bg-no-repeat bg-cover z-10`}
          style={{
            backgroundImage: `url(${be}${
              findContentByTitle(contents, 'WORK HARD PLAY HARDER')?.image?.url
            }`,
          }}
        >
          <img
            src="/images/career/Opacity_career.png"
            className={`absolute ${style.backgroundFilter} w-screen`}
            alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย"
            loading="lazy"
          />
          <p
            className={`tracking-tight flex flex-col text-white mb-10 ${cultureStyle.workHardText}`}
          >
            {findContentByTitle(contents, 'WORK HARD PLAY HARDER')
              ? findContentByTitle(
                  contents,
                  'WORK HARD PLAY HARDER',
                )?.subContent.map((item, i) => (
                  <span key={i} className="text-8xl mb-16 z-20">
                    {animation(translate(item, 'description', lang))}
                  </span>
                ))
              : ''}
          </p>
        </div>
      )}

      <div>
        <Header
          content={{
            title:
              'Culture & Career at CODIUM - ร่วมงานกับทีมดิจิทัลเนทีฟชั้นนำ',
            content:
              'ค้นพบวัฒนธรรมการทำงานที่ CODIUM และร่วมเป็นส่วนหนึ่งของทีมดิจิทัลเนทีฟชั้นนำในประเทศไทย สร้างสรรค์นวัตกรรมและเติบโตไปพร้อมกับเรา',
            image: null,
          }}
        />
        {/* Reason */}
        <div className="p-16 flex flex-row mb-12 xl:mb-0 xl:px-40">
          <img
            src={`${be}${
              findContentByTitle(contents, 'reasons why')
                ? findContentByTitle(contents, 'reasons why').image?.url
                : ''
            }`}
            alt={
              findContentByTitle(contents, 'reasons why')?.image
                ?.alternativeText
            }
            loading="lazy"
          />
          <h1
            className="text-6xl xl:text-4xl mt-24 xl:mt-12 ml-4"
            dangerouslySetInnerHTML={{
              __html: findContentByTitle(contents, 'reasons why')?.description,
            }}
          ></h1>
        </div>

        {/* MOBILE */}
        <div className="p-16 grid grid-cols-1 mb-8 md:grid-cols-3 xl:px-32 xl:hidden">
          {' '}
          {findContentByTitle(contents, 'reasons why')?.subContent.map(
            (item, i) => (
              <span
                className="relative mb-8"
                key={i}
                onClick={() => showReasonWhy(item.name)}
              >
                {showReason && showReason === item.name ? (
                  ''
                ) : (
                  <span
                    className={`md:hidden text-8xl font-normal absolute md:text-4xl h-8   ${
                      i % 2 === 1 ? 'top-20' : 'bottom-36'
                    }`}
                  >
                    {translate(item, 'title', lang)}
                  </span>
                )}
                <h1 className="text-4xl md:hidden font-normal text-right md:text-xl">
                  {item.name}
                </h1>
                <div className="grid grid-cols-2 md:grid-cols-1">
                  <div></div>
                  <h1>
                    <span
                      className="hidden md:block text-8xl font-normal md:text-4xl"
                      style={{ top: '35px' }}
                    >
                      {translate(item, 'title', lang)}{' '}
                      <span className="text-4xl font-normal text-right md:text-xl">
                        {item.name}
                      </span>
                    </span>
                  </h1>
                </div>
                <img
                  src={`${be}${item?.image[0]?.url}`}
                  alt={item?.image[0]?.alternativeText}
                  className="m-auto h-32 mb-16 sm:mb-0"
                  loading="lazy"
                />
                {showReason !== item.name ? (
                  <img
                    src="/images/career/arrowdown.png"
                    className={`h-8 absolute right-0  ${
                      i % 2 === 0 ? 'top-16' : 'bottom-20'
                    } animate-bounce cursor-pointer`}
                    alt=""
                    loading="lazy"
                  />
                ) : (
                  ''
                )}
                {showReason === item.name ? (
                  <div
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    onClick={() => showReasonWhy(null)}
                    data-aos-duration="100"
                    className={`text-white ${
                      cultureStyle['secondary']
                    } rounded-lg p-16 sm:p-10 text-4xl mb-12 md:text-xl xl:absolute  xl:z-50 ${
                      lang === 'th' ? 'thai-lh' : ''
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: translate(item, 'description', lang),
                    }}
                  ></div>
                ) : (
                  ''
                )}
              </span>
            ),
          )}
        </div>

        {/* DESKTOP */}
        <div className="p-16 hidden grid-cols-1 mb-8 md:grid-cols-3 xl:grid xl:px-48">
          {findContentByTitle(contents, 'reasons why')?.subContent.map(
            (item, i) => (
              <div
                className="relative mb-16 cursor-pointer"
                key={i}
                onMouseOver={() => showReasonWhy(item.name)}
                onMouseLeave={() => showReasonWhy(null)}
              >
                <span className="md:hidden text-8xl font-normal absolute md:text-4xl xl:text-base h-8">
                  {translate(item, 'title', lang)}
                </span>
                <h1 className="text-4xl md:hidden font-normal text-right md:text-xl">
                  {item.name}
                </h1>
                <div className="grid relative">
                  <h1 className="absolute">
                    <span
                      className="hidden md:block text-8xl text-right font-normal md:text-4xl xl:text-md"
                      style={{ top: '35px' }}
                    >
                      {translate(item, 'title', lang)}{' '}
                      <span className="text-4xl font-normal text-right md:text-xl xl:text-xl">
                        {item.name}
                      </span>
                    </span>
                  </h1>
                </div>
                <img
                  src={`${be}${item.image[0]?.url}`}
                  alt={item?.image[0]?.alternativeText}
                  className={`m-auto h-32 ${showReason ? 'mb-0' : ''}`}
                  onMouseOver={() => showReasonWhy(item.name)}
                  loading="lazy"
                />
                {
                  <img
                    src="/images/career/arrowdown.png"
                    className="h-8 absolute right-0 bottom-8 animate-bounce cursor-pointer xl:h-4"
                    alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย"
                    loading="lazy"
                  />
                }
                {showReason === item.name ? (
                  <div
                    data-aos="fade-down"
                    data-aos-easing="linear"
                    data-aos-duration="300"
                    className={`text-white ${
                      cultureStyle['secondary']
                    } min-h-36 shadow-md p-8 text-4xl mb-4 rounded-lg font-light md:text-xs xl:text-xs xl:absolute xl:top-8  xl:z-50 ${
                      lang === 'th' ? 'thai-lh' : ''
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: translate(item, 'description', lang),
                    }}
                  ></div>
                ) : (
                  ''
                )}
              </div>
            ),
          )}
        </div>

        {/* benefit */}

        <div
          ref={benefitSectionRef}
          className={`p-16  flex flex-col ${style.bgBlue} justify-center text-white relative xl:px-16 xl:pt-8`}
        >
          {
            <Content
              contents={titleOnly(findContentByTitle(contents, 'OUR BENEFIT'))}
            />
          }
          <div className="grid grid-cols-2 lg:grid-cols-3 w-fullscreen font-light justify-center text-center xl:grid-cols-4 xl:px-36 xl:mt-8">
            {findContentByTitle(contents, 'OUR BENEFIT')?.subContent.map(
              (item, i) => (
                <div
                  key={i}
                  className={`mb-16 ${showBenefit && 'pointer-events-none'}`}
                  onClick={() => setBenefit(item)}
                  data-aos="fade-down"
                  data-aos-easing="linear"
                  data-aos-duration="350"
                >
                  <img
                    src={`${be}${item.image[0].url}`}
                    alt={item?.image[0]?.alternativeText}
                    className={`m-auto mb-16 h-32 xl:h-16 xl:m-auto xl:mb-4`}
                    loading="lazy"
                  />
                  <h1 className="text-3xl font-normal mb-8 xl:text-base xl:mb-0">
                    {translate(item, 'title', lang)}
                  </h1>
                </div>
              ),
            )}
          </div>
        </div>

        {/* benefit popup */}
        {showBenefit ? (
          <div
            className={`text-3xl fixed ${
              cultureStyle.benefit
            } shadow-sm p-24 pt-4 font-light ${
              cultureStyle.borderBlue
            } text-center rounded-xl shadow-md z-50
            md:hidden ${lang === 'th' ? 'thai-lh' : ''}`}
            data-aos="zoom-in"
            data-aos-easing="linear"
            data-aos-duration="350"
          >
            <div
              className={`${cultureStyle.benefitImg} ${cultureStyle.borderBlue}`}
            >
              <img
                src={`${be}${showBenefit.image[0].url}`}
                alt={showBenefit?.image[0]?.alternativeText}
                className="m-auto h-24"
                loading="lazy"
              />
            </div>
            <div className="font-normal mb-8 text-4xl mt-32">
              {translate(showBenefit, 'title', lang)}

              <div
                className="absolute right-8 top-8 cursor-pointer text-2xl"
                onClick={() => setBenefit(null)}
              >
                <FontAwesomeIcon icon={faTimes} /> CLOSE
              </div>
            </div>
            <p className={`mb-4 text-4xl ${lang === 'th' ? 'thai-lh' : ''}`}>
              {translate(showBenefit, 'description', lang)}
            </p>
          </div>
        ) : (
          ''
        )}

        {CAREERS_ENABLED && (
          <>
        {
          <Content
            contents={titleOnly(
              contents?.find((item) => item.name === 'CAREERS'),
            )}
          />
        }
        {/* CAREERS */}
        <h1 className="text-center text-4xl">
          {' '}
          {
            contents?.find((item) => item.title === 'CAREERS').subContent[0]
              ?.description
          }
        </h1>
        <div className="grid grid-col-1 mt-8 rounded-md md:grid-cols-2  xl:mb-16 xl:px-48">
          {filterContent(contents, 'job')?.map((item, i) => (
            <div
              key={i}
              className="relative m-8 xl:m-4 rounded-md cursor-pointer hover:text-6xl"
              data-aos="fade-up"
              onClick={() => setShowCareerPosition(item.title)}
              style={{
                backgroundImage:
                  showCareer === item.title
                    ? `linear-gradient(#0B273E, #095069)`
                    : '',
              }}
            >
              {/* 'linear-gradient(#0B273E, #095069)' */}
              <h1 className="absolute text-4xl text-white top-16 left-16 xl:top-4 xl:left-8 xl:text-2xl">
                {translate(item, 'title', lang)}
              </h1>
              <img
                src="/images/career/double.svg"
                className="absolute top-24 xl:top-12 left-8"
                alt="อัพโหลดเอกสารต่างๆเข้าระบบอย่างง่ายดาย"
                loading="lazy"
              />
              {showCareer !== item.title ? (
                <img
                  src={`${be}${item.image?.url}`}
                  alt={item?.image[0]?.alternativeText}
                  className="w-screen"
                />
              ) : (
                ''
              )}
              {showCareer === item.title ? (
                <div className="w-100  flex flex-col justify-center mt-16 pb-16 ">
                  <h1 className="text-3xl text-white text-center mt-24 p-8 xl:text-xl xl:p-4 xl:mt-4">
                    {item.description}
                  </h1>
                  {item.subContent.map((sub, subindex) => (
                    <div
                      key={subindex}
                      data-aos="fade-down"
                      data-aos-easing="linear"
                      data-aos-duration="350"
                      className={`text-3xl sm:text-2xl text-white text-center font-light p-8 sm:p-5 m-8 sm:my-5 xl:m-4 xl:text-base xl:p-6 cursor-pointer ${style.bgBlue}`}
                      onClick={() => joinTeam(sub.title, item)}
                    >
                      {sub.title}
                    </div>
                  ))}
                </div>
              ) : (
                ''
              )}
            </div>
          ))}
        </div>

        {/* modal mobile */}
        <div
          className={`text-3xl fixed shadow-lg font-light text-center 
             w-screen  ${
               cultureStyle.careerForm
             } z-20 max-h-screen xl:px-12 xl:py-4 lg:pty-0 ${
            showJoinTeam ? 'visible' : 'invisible'
          }`}
          data-aos="zoom-in"
          data-aos-easing="linear"
          data-aos-duration="350"
          style={{
            zIndex: 90,
            width: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }}
        >
          <div className="w-full h-full bg-white rounded-md xl:w-7/12 xl:mx-auto overflow-y-auto pb-10 mb:pb-0">
            <div className="flex flex-col md:flex-row-reverse justify-between md:p-8">
              <div className="pt-12 px-12 md:p-0">
                <p className="text-right cursor-pointer xl:text-xs">
                  <span onClick={() => closeJoinTeam()}>
                    <FontAwesomeIcon icon={faTimes} /> CLOSE
                  </span>
                </p>
              </div>
              <p
                className="text-5xl font-bold m-8 border-l-8 text-left border-red-400 xl:text-xl xl:m-0 lg:mt-4 pl-8"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    findContent(contents, 'Career Forms'),
                    'title',
                    lang,
                  ),
                }}
              ></p>
            </div>
            <p className="text-4xl font-normal  p-8 xl:text-lg xl:p-0">
              {translate(
                findContent(contents, 'Career Forms'),
                'description',
                lang,
              )}
            </p>
            <form
              className="px-8 xl:p-0"
              onSubmit={handleSubmit(handleSubmitForm)}
            >
              <div className="grid md:grid-cols-2">
                {findContent(contents, 'Career Forms')?.form.map((item, i) => (
                  <span key={i}>
                    {item.inputType === 'text' ? (
                      <div className="my-16 md:m-8 relative">
                        <label className="block text-left text-4xl font-medium text-gray-700 md:text-lg xl:text-sm xl:9/12">
                          {translate(item, 'label', lang)}{' '}
                          {item.required ? (
                            <span className="text-red">*</span>
                          ) : (
                            ''
                          )}
                        </label>
                        <input
                          type="text"
                          className="focus:ring-indigo-500 focus:border-indigo-500 md:text-lg block w-full pl-7 pr-12 sm text-left border-gray-300 border my-4 p-2 rounded xl:9/12 xl:my-2 xl:text-sm"
                          id={`form-${item.name}`}
                          name={item.name}
                          {...register(fieldNameOf(item.name), {
                            ...requiredRule(
                              item.required,
                              translate(item, 'label', lang),
                              lang,
                            ),
                            ...formatRules(item.name, lang),
                          })}
                        />
                        {errors[fieldNameOf(item.name)] && (
                          <p className="text-red text-left text-3xl md:text-lg xl:text-sm -mt-2 mb-2">
                            {errors[fieldNameOf(item.name)].message}
                          </p>
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                    {/* {item.inputType === 'files' ? <><label className="block text-left text-4xl font-medium text-gray-700 xl:text-sm xl:/12 mb-8">{item.label}</label>
                                    <div className="mt-1 h-32 relative border-dashed flex cursor-pointer border-gray-300 border-2" onClick={(e) => upload.click()}>
                                        <p className="text-center m-auto text-gray-300 cursor-pointer">Click to upload</p>
                                        <input type="file" ref={(ref) => setUpload(ref)} onChange={(e) => onFileChange(e)} className="focus:ring-indigo-500 focus:border-indigo-500  w-full pl-7 pr-12 sm border-gray-300 my-8 p-4 text-center xl:my-2 xl:9/12 hidden" placeholder="Click to upload" />
                                    </div> </> : ''}
                                {item.inputType === 'button' ? <div className="flex justify-center py-8">
                                    <button style={{ marginTop: '20px' }} className="btn btn-success-blue font-medium  focus:outline-none p-8 py-8 xl:px-10 "
                                    >
                                        <span className="text-3xl xl:text-sm">{item.label}</span>
                                    </button>
                                </div> : ''} */}
                  </span>
                ))}
              </div>

              {/* Hidden Honeypot Field */}
              <HoneyPot register={register} onChange={() => {}} />

              <div className="mt-4 lg:mt-0">
                {findContent(contents, 'Career Forms')?.form.map((item, i) => (
                  <span key={i}>
                    {item.inputType === 'files' ? (
                      <>
                        <label className="block  md:m-8 text-left text-4xl font-medium text-gray-700 md:text-xl xl:text-sm xl:/12">
                          {translate(item, 'label', lang)}{' '}
                          {item.required ? (
                            <span className="text-red">*</span>
                          ) : (
                            ''
                          )}
                          {showUploadResumeNoti && (
                            <span className="text-red">
                              {lang == 'en'
                                ? 'Please upload your resume.'
                                : 'กรุณาอัปโหลดเรซู่เม่'}
                            </span>
                          )}
                        </label>
                        <div
                          className="mt-1 h-16  md:m-8 relative border-dashed flex border-gray-300 cursor-pointer border-2"
                          onClick={(e) => upload.click()}
                        >
                          <p className="text-center m-auto text-gray-300 xl:text-base">
                            {resume ? resume.name : 'Click to upload'}
                          </p>
                          <input
                            type="file"
                            ref={(ref) => setUpload(ref)}
                            onChange={(e) => onFileChange(e)}
                            className="focus:ring-indigo-500 focus:border-indigo-500  w-full pl-7 pr-12 sm border-gray-300 my-8 p-4 text-center xl:my-2 xl:9/12 hidden"
                            placeholder="Click to upload"
                            accept=".pdf"
                          />
                        </div>{' '}
                      </>
                    ) : (
                      ''
                    )}
                    {item.inputType === 'button' ? (
                      <>
                        <div className="mt-12 text-left text-3xl md:text-xl lg:text-lg xl:text-sm md:mx-8">
                          <p>
                            {lang === 'en'
                              ? 'Please provide only the necessary details when submitting your resume.'
                              : 'โปรดกรอกรายละเอียดข้อมูลที่จำเป็นเท่านั้น สำหรับการส่งเรซูเม่ของคุณ'}
                            <br />
                            <br />
                            {lang === 'en' ? (
                              <>
                                Ensure that you do not include sensitive
                                personal information such as religion,
                                ethnicity, weight, height, etc. If such
                                information is provided, CODIUM will consider it
                                as your consent to disclose this information to
                                us.
                              </>
                            ) : (
                              <>
                                โปรดทำให้แน่ใจว่าคุณไม่ได้ระบุข้อมูลส่วนบุคคลอ่อนไหว
                                เช่น ศาสนา เชื้อชาติ น้ำหนัก ส่วนสูง เป็นต้น
                                ในกรณีที่มีการกรอก/ระบุข้อมูลดังกล่าว CODIUM
                                จะถือว่าคุณยินยอมเปิดเผยข้อมูลในส่วนนั้นให้กับทาง
                                CODIUM เอง
                              </>
                            )}
                            <br />
                            <br />
                            {lang === 'en'
                              ? 'You can read more about how we protect your personal data in our'
                              : 'โปรดอ่านรายละเอียดเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของคุณได้ที่นี่'}{' '}
                            <Link href={'/privacy-policy'} passHref>
                              <a
                                target="_blank"
                                className="underline text-lightBlue hover:text-lightBlue-600"
                              >
                                {lang === 'en'
                                  ? 'Privacy Policy.'
                                  : 'นโยบายความเป็นส่วนตัว'}
                              </a>
                            </Link>
                          </p>
                        </div>
                        <div className="w-fit mx-auto py-5">
                          <Turnstile
                            turnstileSiteKey={turnstileSiteKey}
                            callback={(token) => handleRecaptchaChange(token)}
                            theme="light"
                          />
                        </div>
                        <div className="flex justify-center mb-[10rem] lg:mb-6">
                          <Button
                            type="submit"
                            className="disabled:opacity-30"
                            icon="/icons/paper_plane.svg"
                            text={
                              isSubmitting
                                ? lang === 'en'
                                  ? 'Sending...'
                                  : 'กำลังส่งข้อมูล...'
                                : lang === 'en'
                                ? 'Send'
                                : 'ส่งข้อมูล'
                            }
                            disabled={!confirmRecaptcha || isSubmitting}
                          ></Button>
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                  </span>
                ))}
              </div>
            </form>
          </div>
        </div>
          </>
        )}
      </div>
    </>
  );
};

ESignature.getLayout = (page: ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default ESignature;
